import { Component, input, inject, ChangeDetectionStrategy } from '@angular/core';

import {MatIcon} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-card',
  imports: [MatIcon, RouterLink],
  templateUrl: './card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './card.component.css',
})
export class CardComponent {
  private sanitizer = inject(DomSanitizer);


  hrefLink = input<string>('');
  fragment = input<string>('');
  title = input<string>();
}
